import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Alert, DialogActions, DialogTitle, FormHelperText, Grid } from '@mui/material';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import * as React from 'react';
import { useUser } from 'src/components/hooks/useUser';
import { sendRequest } from 'src/hooks/useFetch';
import { useAppDispatch } from 'src/store/hooks';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import Loader from '../common/Loader';

export interface ISubArtifactData {
  id: string;
  version: string;
}
export default function FormDialog(props: any) {
  const dispatchApp = useAppDispatch();
  const { user } = useUser();
  const versionType = props.versionNumber;
  const subartifactVersions = props.subartifactVersions;
  const [subartifactDocId, setSubArtifactDocId] = React.useState<ISubArtifactData>({ id: '', version: '' });
  const [disableSave, setDisableSave] = React.useState(false);

  const handleBackDialogSubArtifact = () => {
    props.setIsChanged(true);
    props.setOpenSubartifact(false);
  };

  const handleCloseDialogSubArtifact = () => {
    props.setSubmitDisable(true);
    props.setOpenSubartifact(false);
    props.handleBackVersion();
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    props.setIsChanged(true);
    setSubArtifactDocId({ id: value, version: event.target.name });
  };

  const handleSaveDialogSubArtifact = async () => {
    setDisableSave(true);
    if (subartifactDocId.id !== '') {
      dispatchApp(showLoader());
      try {
        const filteredSubartifactVer = subartifactVersions.filter(
          (subVersion: any) => subVersion.tmf_document_id === subartifactDocId.id
        );
        const options = {
          endPointEnv: 'etmf',
          study_id: filteredSubartifactVer[0].tmf_doc_study,
          pathVariables: {
            tmfDocumentId: subartifactDocId.id,
            docVersionNumber: filteredSubartifactVer[0].tmf_doc_version_number,
            appName: process.env.REACT_APP_NAME,
            ...(filteredSubartifactVer[0].tmf_doc_country && { countryId: filteredSubartifactVer[0].tmf_doc_country }),
            ...(filteredSubartifactVer[0].tmf_doc_site && { siteId: filteredSubartifactVer[0].tmf_doc_site })
          }
        };
        const docToBeUpdated: any = await sendRequest(
          filteredSubartifactVer[0].tmf_doc_country && filteredSubartifactVer[0].tmf_doc_site
            ? 'get_documents_by_studyid_tmf_document_id_tmf_doc_version_number_sitelevel'
            : 'get_documents_by_studyid_tmf_document_id_tmf_doc_version_number_studylevel',
          options
        );

        const subartifactUpdateObj = {
          file_master_id: props.resData.id,
          document_data: {
            tmf_artifact_number: docToBeUpdated.document_data.tmf_artifact_number,
            tmf_document_name: props.metaData.tmf_document_name,
            tmf_doc_type: docToBeUpdated.document_data.tmf_doc_type,
            tmf_doc_subtype: docToBeUpdated.document_data.tmf_doc_subtype,
            tmf_doc_viewer_req_certified_copy: docToBeUpdated.document_data.tmf_doc_viewer_req_certified_copy,
            tmf_doc_status: docToBeUpdated.document_data.tmf_doc_status,
            tmf_doc_country: docToBeUpdated.document_data.tmf_doc_country,
            tmf_doc_study: docToBeUpdated.document_data.tmf_doc_study,
            tmf_doc_site: docToBeUpdated.document_data.tmf_doc_site,
            tmf_doc_viewer_department: docToBeUpdated.document_data.tmf_doc_viewer_department,
            tmf_doc_viewer_language: docToBeUpdated.document_data.tmf_doc_viewer_language,
            tmf_doc_viewer_approval_cycle: docToBeUpdated.document_data.tmf_doc_viewer_approval_cycle,
            tmf_doc_viewer_product_detail: docToBeUpdated.document_data.tmf_doc_viewer_product_detail,
            tmf_doc_viewer_ref_model_version: docToBeUpdated.document_data.tmf_doc_viewer_ref_model_version,
            tmf_doc_viewer_format: docToBeUpdated.document_data.tmf_doc_viewer_format,
            tmf_doc_viewer_inspection_ready: docToBeUpdated.document_data.tmf_doc_viewer_inspection_ready,
            tmf_doc_viewer_ir_issue_type: docToBeUpdated.document_data.tmf_doc_viewer_ir_issue_type,
            tmf_doc_level: docToBeUpdated.document_data.tmf_doc_level,
            tmf_artifact_name: docToBeUpdated.document_data.tmf_artifact_name,
            tmf_doc_version_number: subartifactDocId.version,
            tmf_doc_milestone: docToBeUpdated.document_data.tmf_doc_milestone,
            tmf_document_id: subartifactDocId.id,
            id: docToBeUpdated.document_data.id,
            tmf_doc_last_modified_by: user
          }
        };
        versionType === 'Major' || versionType === 'Minor'
          ? props.putUpdatedData({ ...subartifactUpdateObj, tmf_doc_new_version_number: subartifactDocId.version })
          : props.overwriteVersionData(subartifactUpdateObj);
      } catch (error: any) {
        dispatchApp(setMessage({ msgDetails: `Error in getting document details.`, severity: 'error' }));
      }
      dispatchApp(hideLoader());
      props.setIsChanged(false);
    }
  };

  const getDialogTitle = (versionNo: any) => {
    if (versionNo === 'Major') {
      return 'Select Subartifact to Update as Major Change';
    } else if (versionNo === 'Minor') {
      return 'Select Subartifact to Update as Minor Change';
    } else if (versionNo === 'Overwrite') {
      return 'Select Subartifact to Overwrite';
    }
  };
  return (
    <>
      <Loader />
      <DialogTitle>{getDialogTitle(props.versionNumber)}</DialogTitle>
      <DialogContent className="selectSubArtifact-modalcontent" dividers>
        {props.versionNumber === 'Overwrite' && (
          <Alert severity="info">Overwriting will replace the current document</Alert>
        )}
        <dl>
          <dt>Artifact: {subartifactVersions[0].tmf_artifact_name}</dt>
        </dl>
        <dl>
          <dt>Subartifacts Uploaded:</dt>
        </dl>
        <FormControl className="special-radiobtn-group">
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue={subartifactDocId.id}
            name="radio-buttons-group"
            onChange={handleRadioChange}
          >
            {subartifactVersions.map((artifact: any) => {
              if (versionType === 'Major' || versionType === 'Minor') {
                return (
                  <Grid key={artifact.tmf_document_id}>
                    <FormControlLabel
                      name={
                        versionType === 'Major'
                          ? Math.floor(artifact.tmf_doc_version_number + 1.0).toFixed(1)
                          : (artifact.tmf_doc_version_number + 0.1).toFixed(1)
                      }
                      value={artifact.tmf_document_id}
                      control={<Radio />}
                      label={artifact.tmf_document_name}
                      labelPlacement="start"
                      sx={{
                        '& .MuiSvgIcon-root': {
                          fontSize: 24
                        },
                        fontWeight: 'medium'
                      }}
                      disabled={disableSave}
                    />
                    <FormHelperText>
                      <span> Current: Version {artifact.tmf_doc_version_number.toFixed(1)}</span>{' '}
                      <ArrowRightAltIcon sx={{ display: 'inline' }} />
                      <span>
                        After Update: Version{' '}
                        {versionType === 'Major'
                          ? Math.floor(artifact.tmf_doc_version_number + 1.0).toFixed(1)
                          : (artifact.tmf_doc_version_number + 0.1).toFixed(1)}
                      </span>
                    </FormHelperText>
                  </Grid>
                );
              } else {
                return (
                  <Grid key={artifact.tmf_document_id}>
                    <FormControlLabel
                      name={artifact.tmf_doc_version_number.toFixed(1)}
                      value={artifact.tmf_document_id}
                      control={<Radio />}
                      label={artifact.tmf_document_name}
                      labelPlacement="start"
                      sx={{
                        '& .MuiSvgIcon-root': {
                          fontSize: 24
                        }
                      }}
                      disabled={disableSave}
                    />
                    <FormHelperText>
                      <span>Overwrite current version: {artifact.tmf_doc_version_number.toFixed(1)}</span>
                    </FormHelperText>
                  </Grid>
                );
              }
            })}
          </RadioGroup>
        </FormControl>{' '}
        <br />
        <br />
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <div>
          <Button onClick={handleBackDialogSubArtifact} className="normal-btn" disabled={disableSave}>
            Back
          </Button>
        </div>
        <div>
          <Button onClick={handleCloseDialogSubArtifact} className="normal-btn" disabled={disableSave}>
            Close
          </Button>
          <Button onClick={handleSaveDialogSubArtifact} disabled={!props.isChanged}>
            Save
          </Button>
        </div>
      </DialogActions>
      {/*---- to call "Select Subartifact" modal newly added for Sprint 10 ends ----- */}
    </>
  );
}
